const MessageType = {
  text: 'text',
  media: 'media',
};

export default MessageType;
